export default {
  namespaced: true,
  name: 'SLSUsuarioClienteStore',
  state: {
    clientesNaoSelecionados: [],
    clientesSelecionados: [],
    loading: false,
    filtersNaoSelecionado: {
      page: 1,
      perPage: 8,
      sortBy: null,
      sortDesc: null,
      codigo: null,
      clienterazaosocial: null,
    },
    filtersSelecionado: {
      page: 1,
      perPage: 8,
      sortBy: null,
      sortDesc: null,
      codigo: null,
      clienterazaosocial: null,
    },

  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setCodigoNaoSelecionado(state, payload) {
      state.filtersNaoSelecionado.codigo = payload;
    },
    setClienteRazaoSocialNaoSelecionado(state, payload) {
      state.filtersNaoSelecionado.clienterazaosocial = payload;
    },
    setCodigoSelecionado(state, payload) {
      state.filtersSelecionado.codigo = payload;
    },
    setClienteRazaoSocialSelecionado(state, payload) {
      state.filtersSelecionado.clienterazaosocial = payload;
    },
    setPageNaoSelecionado(state, payload) {
      state.filtersNaoSelecionado.page = payload;
    },
    setFiltersNaoSelecioando(state, payload) {
      state.filtersNaoSelecionado = payload;
    },
    setFiltersSelecionados(state, payload) {
      state.filtersSelecionado = payload;
    },
    setUsuariosCliente(state, payload) {
      state.usuariosClientes = payload;
    },
    setClientesNaoSelecionados(state, payload) {
      state.clientesNaoSelecionados = payload;
    },
    setClientesSelecionados(state, payload) {
      state.clientesSelecionados = payload;
    },
  },
  getters: {
    getLoading(state) {
      return state.loading;
    },
    getFiltersNaoSelecionado(state) {
      return state.filtersNaoSelecionado;
    },
    getFiltersSelecionado(state) {
      return state.filtersSelecionado;
    },
    getClientesNaoSelecionados(state) {
      return state.clientesNaoSelecionados;
    },
    getClientesSelecionados(state) {
      return state.clientesSelecionados;
    },
  },
};
